import React from 'react'
import styled from 'styled-components'
import { Avatar } from '../Avatar'

const Border = styled.div`
  display: flex;
  flex-direction: row;
  border: 1px dashed ${({ theme }) => theme.colors.border.A};
  align-items: center;
  padding: 8px;
  background: ${({ theme }) => theme.colors.background.secondary.B};
  border-radius: 6px;
`

const Email = styled.span`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: ${({ theme }) => theme.fontSizes.E};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  margin: 0 8px;
`

interface UserChipProps {
  name: string
  email: string
  avatarSrc?: string
}

export const UserChip = ({ name, email, avatarSrc }: UserChipProps) => {
  return (
    <Border data-testid="user-chip">
      <Avatar name={name} src={avatarSrc} size={24} />
      <Email>{email}</Email>
    </Border>
  )
}
